import 'react-app-polyfill/stable';
import 'core-js/actual/global-this';
import './utils/cryptoPolyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { Provider } from 'react-redux';
// import store from './global/Store';
import { rootSaga, store, sagaMiddleware } from './modules/redux/sagas'
import './i18n/config'
import './tailwind.css';

sagaMiddleware.run(rootSaga);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "OpenSans",
          },
          components: {
            Carousel: {
              dotWidth: '6px',
              dotHeight: "6px",
              dotActiveWidth: "30px"
            }
          },
        }}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </ConfigProvider>
    </StyleProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
